import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const countriesApi = createApi({
  reducerPath: 'countriesApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['countries'],
  endpoints: (builder) => ({
    getAllCountries: builder.mutation({
      query(body) {
        return {
          url: spotFinder.countryController.getAllContries,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

export const {
  useGetAllCountriesMutation,
} = countriesApi;
